import S from 'string'
import axios from 'axios'
import jwt from 'jwt-decode'

import unimedLogo from '@assets/images/unimed-assis/logo.svg'
import cynthiaLogo from '@assets/images/cynthia-charone/logo.svg'
import unimedRelatoryLogo from '@assets/images/title-logo-unimed-assis.jpg'

const tokenKeyName = 'accessToken'

export const getLogoByInsurer = (insurance) => {
  let logo
  if (insurance === 'unimed-assis') {
    logo = unimedLogo
  } else if (insurance === 'cynthia-charone') {
    logo = cynthiaLogo
  }
  return logo
}

export const getLogoFromRelatory = (insurance) => {
  let logo
  if (insurance === 'unimed-assis') {
    logo = unimedRelatoryLogo
  } else if (insurance === 'cynthia-charone') {
    logo = cynthiaLogo
  }
  return logo
}

class AuthUtil {
  static init() {
    const storedToken = AuthUtil.getAccessToken()
    if (storedToken && jwt(storedToken).exp < Date.now() / 1000) {
      localStorage.clear()
      AuthUtil.configureAuthorizationHeader('')
    } else {
      AuthUtil.configureAuthorizationHeader(storedToken)
    }
  }

  static configureAuthorizationHeader(token) {
    if (!S(token).isEmpty()) {
      axios.defaults.headers.common.Authorization = token
    } else {
      axios.defaults.headers.common.Authorization = null
    }
  }

  static saveToken(token) {
    window.localStorage.setItem(tokenKeyName, token)
  }

  static clearAccessToken() {
    window.localStorage.removeItem(tokenKeyName)
  }

  static getAccessToken() {
    return window.localStorage.getItem(tokenKeyName)
  }

  static newSession(token) {
    AuthUtil.configureAuthorizationHeader(token)
    AuthUtil.saveToken(token)
  }

  static clearSession() {
    AuthUtil.configureAuthorizationHeader(null)
    AuthUtil.clearAccessToken()
  }

  static getExpirationToken() {
    const storedToken = AuthUtil.getAccessToken()
    return storedToken && jwt(storedToken).exp
  }
}

export default AuthUtil
